import { render, staticRenderFns } from "./buy-tickets.vue?vue&type=template&id=0a6cae80"
import script from "./buy-tickets.vue?vue&type=script&lang=js"
export * from "./buy-tickets.vue?vue&type=script&lang=js"
import style0 from "./buy-tickets.vue?vue&type=style&index=0&id=0a6cae80&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6cae80')) {
      api.createRecord('0a6cae80', component.options)
    } else {
      api.reload('0a6cae80', component.options)
    }
    module.hot.accept("./buy-tickets.vue?vue&type=template&id=0a6cae80", function () {
      api.rerender('0a6cae80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buy-tickets.vue"
export default component.exports